import { cn } from '~/utils/cn'

const levels = {
  1: 'text-3xl md:text-4xl font-bold leading-relaxed',
  2: 'text-xl md:text-3xl font-bold leading-relaxed',
  3: 'text-lg md:text-2xl font-medium leading-relaxed',
  4: 'text-base md:text-xl font-medium leading-relaxed',
  5: 'text-base md:text-lg font-medium leading-loose',
} as const

type Props = {
  level?: 1 | 2 | 3 | 4 | 5
  bold?: boolean
  as?: React.ElementType
  className?: string
  children: React.ReactNode
}

export const HeadingTW = ({
  level = 1,
  bold,
  as,
  className,
  children,
}: Props) => {
  const Tag = as || (`h${level}` as React.ElementType)

  return (
    <Tag
      className={cn(
        'font-heading text-dark',
        levels[level],
        bold && 'font-bold',
        className
      )}
    >
      {children}
    </Tag>
  )
}
